import React, { useState, useEffect } from 'react';
import { useLazyQuery } from "@apollo/client";
import { Box, Flex, Grid, Heading, Text, Icon } from "@chakra-ui/react";
import {
  FaCamera,
  FaSpa,
  FaUtensils,
  FaMusic,
  FaPalette,
  FaSeedling,
  FaRunning,
  FaTools,
  FaThLarge
} from "react-icons/fa";
import { HOBBY } from "../../constants"
import {
  DYNOCATEGORIES
} from "../../graphql/queries";
import { useStore } from "../../Store";


export const Hobby = ({ product, type }) => {

  const [dynoSubCategory, setDynoSubCategory] = useState([]);
  const {updateStates} = useStore((state) => state);

  const categories = {
    "Photography": {
      icon: FaCamera,
      description: "Digital, Film, Portrait"
    },
    "Yoga": {
      icon: FaSpa,
      description: "Meditation, Fitness"
    },
    "Cooking": {
      icon: FaUtensils,
      description: "Culinary Arts, Baking"
    },
    "Music": {
      icon: FaMusic,
      description: "Instruments, Voice"
    },
    "Art & Craft": {
      icon: FaPalette,
      description: "Drawing, Painting"
    },
    "Gardening": {
      icon: FaSeedling,
      description: "Indoor, Outdoor"
    },
    "Dance": {
      icon: FaRunning,
      description: "Various Styles"
    },
    "DIY & Crafts": {
      icon: FaTools,
      description: "Home Projects"
    }
  };

  const [getDynosCategories] = useLazyQuery(DYNOCATEGORIES,
    {
      onCompleted: (data) => {
        const dynoCategories = data.dynoCategories.map(cat => ({
          id: cat.id,
          name: cat.name,
          icon: categories[cat.name]?.icon || FaThLarge,
          description: categories[cat.name]?.description || ""
        }));
        setDynoSubCategory(dynoCategories)
      }
    }
  )

  useEffect(() => {
    getDynosCategories({
      variables: {
        where: {
          parentCategory: {
            name: {
              equals: HOBBY
            }
          }
        }
      }
    })
  }, []);

  return (
    <Box w="100%">
      <Heading as='h3' size='lg' mb={4}>Choose Your Academic Field</Heading>
      <Text fontSize="md" mb={8} color="gray.600">Explore diverse academic disciplines and find your passion</Text>

      <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap={6} maxW="7xl" mx="auto">
        {dynoSubCategory.map((category) => (
          <Box
            key={category.id}
            onClick={() =>  updateStates({
              [type]: {...product, subCategory: category}
            })
            }
            cursor="pointer"
            p={6}
            rounded="lg"
            shadow="md"
            _active={{ transform: "scale(0.98)" }}
            bg={product.subCategory.id === category.id ? "blue.100" : "white"}
            color="#000"
            _hover={{
              bg: "blue.100",
            }}
          >
            <Flex align="start" gap={4}>
              <Box display="flex" alignItems="center" justifyContent="center">
                <Icon as={category.icon} color="blue.500" boxSize={6}/>
              </Box>
              <Box>
                <Heading as="h3" size="sm" mb={1}>{category.name}</Heading>
                <Text fontSize="sm" color="gray.600">{category.description}</Text>
              </Box>
            </Flex>
          </Box>
        ))}
      </Grid>
    </Box>
  );
};

